export default "__VITE_ASSET__1da7350f__"